// NotificationPage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Typography from "@mui/material/Typography";

export const NotificationIndividual = () => {
  const { notificationId } = useParams();
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getNotification = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/notification/indi/${notificationId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setNotification(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getNotification();
  }, [notificationId]);

  if (!notification) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Typography variant="h4" mb={"1.5rem"}>
        Notification Details
      </Typography>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <p>
          <strong>Blog ID:</strong> {notification._id}
        </p>
        <p>
          <strong>Parent ID:</strong> {notification.parent_id._id}
        </p>
        <p>
          <strong>Parent Name:</strong> {notification.parent_id.name}
        </p>
        <p>
          <strong>User ID:</strong> {notification.user_id._id}
        </p>
        <p>
          <strong>User Name:</strong> {notification.user_id.name}
        </p>
        <p>
          <strong>Blog ID:</strong> {notification.blog_id}
        </p>
        <p>
          <strong>Type:</strong> {notification.type}
        </p>
        <p>
          <strong>Status:</strong> {notification.status}
        </p>
        <p>
          <strong>Created At:</strong>{" "}
          {new Date(notification.createdAt).toLocaleString()}
        </p>
        {/* Add more details based on your notification data */}
      </div>
    </div>
  );
};
